import isEqualBounds from 'src/js/modules/common/helpers/is-equal-bounds';
import isGalleryItem from 'src/js/modules/focal-point/helpers/is-gallery-item';
import getOverlappedMediaContainerByText from '../../ws-image/helpers/get-overlapped-media-container-by-text';
import isBusinessLogo from '../../ws-image/helpers/is-business-logo';
import { getMedia, getImage } from './get-media';
import matchesMedia from './matches-media';

const matchesImageMedia = (element) => {
  if (isBusinessLogo(element)) {
    return false;
  }

  const isMediaWithImage = matchesMedia(element) && Boolean(getImage(element));

  if (isMediaWithImage && !isGalleryItem(element)) {
    return true;
  }

  const overlappedMediaContainer = getOverlappedMediaContainerByText(element);

  if (overlappedMediaContainer && !isGalleryItem(overlappedMediaContainer)) {
    return Boolean(getImage(overlappedMediaContainer));
  }

  const mediaContainer = getMedia(element);
  const containsMediaWithImage = Boolean(getImage(mediaContainer));

  if (containsMediaWithImage && !isGalleryItem(mediaContainer)) {
    return isEqualBounds(
      element.getBoundingClientRect(),
      mediaContainer.getBoundingClientRect(),
      true
    );
  }

  return false;
};

const getImageTargetElement = (element) => {
  if (matchesMedia(element)) {
    return element;
  }

  const overlappedMediaContainer = getOverlappedMediaContainerByText(element);

  if (overlappedMediaContainer) {
    return overlappedMediaContainer;
  }

  if (!matchesMedia(element)) {
    return getMedia(element);
  }

  return element;
};

export { matchesImageMedia, getImageTargetElement };
